import React from "react";
import "./ContactUs.css";
import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import ContactUsHero from "../../components/pages/ContactUs/ConctactUsHero/ContactUsHero";
import ContactUsCaRrds from "../../components/pages/ContactUs/ContactUsCards/ContactUsCaRrds";
import Questions from "../../components/pages/Academy/Questions/Questions";
import { useTranslation } from "react-i18next";
import { usePageContent } from "../../hooks/usePublicQueries";

const unwrapSectionData = (section) => {
  if (section == null) return section;
  if (typeof section === "string") {
    const t = section.trim();
    if (t.startsWith("{")) {
      try {
        const parsed = JSON.parse(t);
        if (parsed && typeof parsed === "object") return unwrapSectionData(parsed);
      } catch {
        return section;
      }
    }
    return section;
  }
  if (typeof section !== "object") return section;
  if (section.data && typeof section.data === "object") return section.data;
  return section;
};

const normalizeSectionSlug = (key) =>
  String(key || "")
    .toLowerCase()
    .replace(/[_\s-]+/g, "");

const findPageSection = (root, slug) => {
  if (!root || typeof root !== "object") return undefined;
  const target = normalizeSectionSlug(slug);
  const hit = Object.keys(root).find((k) => normalizeSectionSlug(k) === target);
  return hit != null ? root[hit] : undefined;
};

const ContactUs = () => {
  const { i18n } = useTranslation();
  const { data: contactContent } = usePageContent("contactus", i18n.language);

  return (
    <div className="contactus-page">
      <Navbar theme="dark" />

      <div className="contactus-page-content-guide">
        <ContactUsHero content={unwrapSectionData(findPageSection(contactContent, "hero"))} />
        <ContactUsCaRrds content={unwrapSectionData(findPageSection(contactContent, "details"))} />
        <Questions />
      </div>
      <Footer />
    </div>
  );
};

export default ContactUs;
